import { nanoid } from "nanoid";

const DEVICE_ID_KEY = "poker_device_id";
const SESSION_KEY = "poker_session";

export interface PokerSession {
  roomCode: string;
  playerId: string;
  playerName: string;
}

export function getDeviceId(): string {
  if (typeof window === "undefined") return "";
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = nanoid(32);
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

export function getSavedSession(): PokerSession | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveSession(session: PokerSession): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY);
}
